import React, { useState } from "react";
import Header from "../Components/Header";
import PageHeader from "../Components/PageHeader";
import UserProfileSidebar from "../Components/UserProfileSidebar";
import Footer from "../Components/Footer";
import { Link } from "react-router-dom";
import Select from "react-select"; // Ensure you have this import for the Select component

const UserShiftEdit = () => {
	const specializationOptions = [
		{ value: "Monday", label: "Monday" },
		{ value: "Tuesday", label: "Tuesday" },
		{ value: "Wednesday", label: "Wednesday" },
	];

	const [selectedSpecializations, setSelectedSpecializations] = useState([]);

	const handleChange = (selectedOptions) => {
		setSelectedSpecializations(selectedOptions);
	};

	return (
		<>
			<Header />
			<PageHeader pagename="Edit Shift Timings" />
			<section className="main-sidebar  user-profile">
				<div className="container">
					<div className="row">
						<div className="col-lg-4">
							<UserProfileSidebar />
						</div>
						<div className="col-lg-8">
							<div className="main-profile-content radius-20 p-4">
								<div className="main-heading d-flex align-items-center gap-3 mb-3">
									<div className="edit-btn back">
										<Link to="/">
											<div className="nav-anchor">
												<i className="fa-solid fa-arrow-left"></i>
											</div>
										</Link>
									</div>
									<h5 className="main-heading level-6 main-heading-font dark-color mb-0 wow animate__animated animate__zoomIn animate__delay-1s">
										Edit Shift Timings
									</h5>
								</div>
								<div className="row">
									<div className="col-lg-12">
										<div className="signup-wrapper edit-shifts-main">
											<form>
												<div className="row mb-5">
													<div className="col-lg-11 mx-auto">
														<div className="select-days">
															<h4 className="level-5 main-heading-font dark-color">
																Select Days
															</h4>
															<Select
																isMulti
																name="specializations"
																isSearchable={false}
																options={specializationOptions}
																className="basic-multi-select"
																classNamePrefix="select"
																onChange={handleChange}
																value={selectedSpecializations}
																placeholder="Select days"
															/>
															<div className="row mt-5">
																<div className="col-lg-4 form-group">
																	<h5 className="main-heading-font dark-color level-6 mb-2">
																		Select Days
																	</h5>
																	<div className="custom-select-wrapper mt-3">
																		<select className="form-control custom-select">
																			<option value="">Mon</option>
																			<option value="Tue">Tue</option>
																			<option value="Wed">Wed</option>
																			<option value="Thur">Thur</option>
																			<option value="Fri">Fri</option>
																			<option value="Sat">Sat</option>
																			<option value="Sun">Sun</option>
																		</select>
																	</div>
																	<div className="custom-select-wrapper mt-3">
																		<select className="form-control custom-select">
																			<option value="Tue">Tue</option>
																			<option value="Wed">Wed</option>
																			<option value="Thur">Thur</option>
																			<option value="Fri">Fri</option>
																			<option value="Sat">Sat</option>
																			<option value="Sun">Sun</option>
																		</select>
																	</div>
																	<div className="custom-select-wrapper mt-3">
																		<select className="form-control custom-select">
																			<option value="Wed">Wed</option>
																			<option value="Thur">Thur</option>
																			<option value="Fri">Fri</option>
																			<option value="Sat">Sat</option>
																			<option value="Sun">Sun</option>
																		</select>
																	</div>
																</div>
																<div className="col-lg-4 form-group">
																	<h5 className="main-heading-font text-center dark-color level-6 mb-2">
																		Start
																	</h5>
																	<div className="custom-select-wrapper mt-3">
																		<select className="form-control custom-select">
																			<option value="">00:00 AM</option>
																		</select>
																	</div>
																	<div className="custom-select-wrapper mt-3">
																		<select className="form-control custom-select">
																			<option value="">00:00 AM</option>
																		</select>
																	</div>
																	<div className="custom-select-wrapper mt-3">
																		<select className="form-control custom-select">
																			<option value="">00:00 AM</option>
																		</select>
																	</div>
																</div>
																<div className="col-lg-4 form-group">
																	<h5 className="main-heading-font dark-color text-center level-6 mb-2">
																		End
																	</h5>
																	<div className="custom-select-wrapper mt-3">
																		<select className="form-control custom-select">
																			<option value="">00:00 PM</option>
																		</select>
																	</div>
																	<div className="custom-select-wrapper mt-3">
																		<select className="form-control custom-select">
																			<option value="">00:00 PM</option>
																		</select>
																	</div>
																	<div className="custom-select-wrapper mt-3">
																		<select className="form-control custom-select">
																			<option value="">00:00 PM</option>
																		</select>
																	</div>
																</div>
															</div>
														</div>
														<div className="row">
															<div className="col-lg-12">
																<Link
																	className="btn wrapper-btn-main w-100 log-in mt-4 level-7 primary-regular-font text-decoration-none"
																	to="/physician-personal-info"
																>
																	<span className="bg-wrapper w-100">
																		Submit
																	</span>
																</Link>
															</div>
														</div>
													</div>
												</div>
											</form>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</section>
			<Footer />
		</>
	);
};

export default UserShiftEdit;
